import React, { Component } from 'react';
import classNames from 'classnames';
import { PaddedSection } from '../../atoms';
import { OPTIMIZED_RESIZE } from '../../../utils/optimisedResize';

import './styles.css';

const UA = navigator.userAgent.toLowerCase();
const MQ_SMALL_SCREEN = '(max-width: 1199px)';

/**
 * A template for the hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {String} heading
 * @prop {String} href
 * @prop {String} [className]
 * @prop {Object} [forwardedRef]
 *
 * @augments {Component<Props>}
 */
export default class QrHero extends Component {

	state = {
		isSmallScreen: window.matchMedia(MQ_SMALL_SCREEN).matches,
		minHeight: Math.trunc(window.innerHeight),
		prevWidth: window.innerWidth,
	};

	componentDidMount () {
		window.addEventListener(OPTIMIZED_RESIZE, this.setInnerHeight);
		this.mql = window.matchMedia(MQ_SMALL_SCREEN);
		this.mql.addListener(this.handleMediaChange);
	}

	componentWillUnmount () {
		window.removeEventListener(OPTIMIZED_RESIZE, this.setInnerHeight);
	}

	genClassName = (props) => classNames('QrHero', props.className);

	isMobileChrome = (/chrome/.test(UA) && /android/.test(UA)) || /crios/.test(UA);

	setInnerHeight = () => {
		// Don't update the height when the address bar shows/hides on Chrome.
		if (this.isMobileChrome && this.state.prevWidth === window.innerWidth) return;

		this.setState({
			minHeight: Math.trunc(window.innerHeight),
			prevWidth: window.innerWidth,
		});
	}

	handleMediaChange = ({ matches }) =>
		this.setState({
			isSmallScreen: !!matches,
		});

	render () {
		const { forwardedRef, heading } = this.props;
		const className = this.genClassName(this.props);
		return (
			<PaddedSection
				className={className}
				forwardedRef={forwardedRef}
				style={{ minHeight: this.state.minHeight }}
			>
				<h1>{heading}</h1>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/QrHero/QrHero.js